var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('action-tile',{attrs:{"image":"my-dossiers.svg","max-image-width":"200px","title":"my-dossiers.page-title"},on:{"click":_vm.navigateToMyDossiers}})
}
var staticRenderFns = []

export { render, staticRenderFns }